// import React, { useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import { useOrderDetailsQuery } from "../../redux/api/orderApi";
// import Loader from "../layout/Loader";
// import MetaData from "../layout/MetaData";
// import toast from "react-hot-toast";

// const OrderDetails = () => {
//   const params = useParams();
//   const { data, error, isLoading } = useOrderDetailsQuery(params?.id);

//   useEffect(() => {
//     if (error) {
//       toast.error(error?.data?.message || "Failed to fetch order details");
//     }
//   }, [error]);

//   if (isLoading) return <Loader />;

//   const order = data?.order || [];
//   const {
//     shippingInfo,
//     orderItems,
//     paymentInfo,
//     user,
//     totalAmount,
//     orderStatus,
//   } = order;

//   return (
//     <>
//       <MetaData title={`Order #${order?._id}`} />

//       <section className="max-w-5xl mx-auto px-6 py-12 font-sourcesans">
//         <div className="flex justify-between items-start">
//         <h2 className="text-3xl font-playfair text-yellow-950 mb-8 ">
//           Order Details
//         </h2>
//         <Link
//             className="bg-green-100 text-green-700 py-2 px-2"
//             to={`/receipt/order/${data?.order?._id}`}
//           >
//             <i className="fa fa-print"></i> Receipt
//           </Link>
//           </div>
//         {/* Order Summary */}
       
//         <div className="bg-[#f5f5dc] p-6 rounded-md border border-stone-300 shadow-sm mb-8">
//           <p className="text-lg font-semibold text-yellow-950 mb-2">
//             Order ID: <span className="font-normal">{order?._id}</span>
//           </p>
//           <p
//             className={`inline-block py-2 px-2 rounded-md text-md font-medium ${
//               order?.orderStatus === "Delivered"
//                 ? "bg-green-100 text-green-700"
//                 : "bg-amber-100 text-amber-700"
//             }`}
//           >
//             {orderStatus}
//           </p>
//           <p className="text-md font-semibold text-yellow-950 mt-2">
//             Order Date:{" "}
//             <span className="font-normal">
//               {new Date(order?.createdAt).toLocaleString("en-US")}
//             </span>
//           </p>
//         </div>
       

//         {/* Shipping Info */}
//         <div className="bg-white p-6 rounded-md border border-stone-300 shadow-sm mb-6">
//           <h3 className="text-xl font-playfair text-yellow-950 mb-4">
//             Shipping Information
//           </h3>
//           <p className="text-stone-700">
//             <span className="font-semibold">Name:</span> {order?.user?.name}
//           </p>
//           <p className="text-stone-700">
//             <span className="font-semibold">Email:</span> {order?.user?.email}
//           </p>
//           <p className="text-stone-700">
//             <span className="font-semibold">Phone Number:</span>{" "}
//             {shippingInfo?.phoneNo}
//           </p>
//           <p className="text-stone-700">
//             <span className="font-semibold">Address:</span>{" "}
//             {shippingInfo?.address}, {shippingInfo?.city},{" "}
//             {shippingInfo?.region}, {shippingInfo?.zipCode},{" "}
//             {shippingInfo?.country}
//           </p>
//         </div>

//         {/* Payment Info */}
//         <div className="bg-white p-6 rounded-md border border-stone-300 shadow-sm mb-6">
//           <h3 className="text-xl font-playfair text-yellow-950 mb-4">
//             Payment
//           </h3>
//           <p
//             className={`inline-block px-3 py-1 rounded-md text-sm font-medium ${
//               paymentInfo?.status === "paid"
//                 ? "bg-green-100 text-green-700"
//                 : "bg-red-100 text-red-700"
//             }`}
//           >
//             {paymentInfo?.status?.toUpperCase()}
//           </p>
//           <p className="mt-2 text-stone-700">
//             <span className="font-semibold">Stripe ID: </span>
//             {paymentInfo?.id || "Nill"}
//           </p>
//           <p className="mt-2 text-stone-700">
//             <span className="font-semibold">Amount:</span> ${totalAmount}
//           </p>
//         </div>

//         {/* Ordered Items */}
//         <div className="bg-white p-6 rounded-md border border-stone-300 shadow-sm">
//           <h3 className="text-xl font-playfair text-yellow-950 mb-4">
//             Ordered Items
//           </h3>
//           <ul className="divide-y divide-stone-300">
//             {orderItems?.map((item) => (
//               <li
//                 key={item?._id}
//                 className="flex justify-between items-center py-4"
//               >
//                 <div className="flex items-center space-x-4">
//                   <img
//                     src={item?.image}
//                     alt={item?.name}
//                     className="w-16 h-16 object-contain rounded border"
//                   />
//                  <Link to={`../product/${item.product}`}
//                     className="text-yellow-950 font-medium hover:text-amber-700"
//                   >
//                     {item?.name}
//                   </Link>
//                 </div>
//                 <p className="text-stone-700">
//                   {item?.quantity} × ${item?.price} ={" "}
//                   <span className="font-semibold">
//                     ${item?.quantity * item?.price}
//                   </span>
//                 </p>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OrderDetails;

import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useOrderDetailsQuery } from "../../redux/api/orderApi";
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";

const OrderDetails = () => {
  const params = useParams();
  const { data, error, isLoading } = useOrderDetailsQuery(params?.id);

  useEffect(() => {
    if (error) {
      toast.error(error?.data?.message || "Failed to fetch order details");
    }
  }, [error]);

  if (isLoading) return <Loader />;

  const order = data?.order || {};
  const { shippingInfo, orderItems, paymentInfo, totalAmount, orderStatus } =
    order;

  // Order progress states
  const steps = ["Placed", "Processing", "Shipped", "Delivered"];
  const currentStep = steps.indexOf(orderStatus);

  return (
    <>
       <Helmet>
        <title>Order Details</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="max-w-6xl mt-20 md:mt-48 x-auto px-4 lg:px-8 py-10 font-sourcesans grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* LEFT: Order Info */}
        <div className="lg:col-span-2 space-y-6">
          {/* Order Progress */}
          <div className="bg-white p-6 rounded-lg border border-stone-200 shadow-sm">
            <h2 className="text-2xl font-playfair text-[#BC3F4A] mb-4">
              Order Status
            </h2>
            <div className="flex justify-between items-center text-sm font-medium text-stone-600">
              {steps.map((step, idx) => (
                <div
                  key={step}
                  className={`flex-1 flex flex-col items-center ${
                    idx <= currentStep ? "text-[#BC3F4A]" : "text-stone-400"
                  }`}
                >
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-full border-2 ${
                      idx <= currentStep
                        ? "border-[#BC3F4A] bg-[#BC3F4A] text-white"
                        : "border-stone-300 bg-white"
                    }`}
                  >
                    {idx + 1}
                  </div>
                  <span className="mt-2">{step}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Shipping Info */}
          <div className="bg-white p-6 rounded-lg border border-stone-200 shadow-sm">
            <h3 className="text-xl font-playfair text-[#BC3F4A] mb-4">
              Shipping Information
            </h3>
            <div className="space-y-2 text-stone-700">
              <p>
                <span className="font-semibold">Name:</span> {order?.user?.name || order?.guestEmail || "Guest"}
              </p>
              <p>
                <span className="font-semibold">Email:</span>{" "}
                {order?.user?.email || order?.guestEmail || "N/A"}
              </p>
              <p>
                <span className="font-semibold">Phone:</span>{" "}
                {shippingInfo?.phoneNo}
              </p>
              <p>
                <span className="font-semibold">Address:</span>{" "}
                {shippingInfo?.address}, {shippingInfo?.city},{" "}
                {shippingInfo?.region}, {shippingInfo?.zipCode},{" "}
                {shippingInfo?.country}
              </p>
            </div>
          </div>

          {/* Payment Info */}
          <div className="bg-white p-6 rounded-lg border border-stone-200 shadow-sm">
            <h3 className="text-xl font-playfair text-[#BC3F4A] mb-4">
              Payment
            </h3>
            <p
              className={`inline-block px-3 py-1 rounded-md text-sm font-medium ${
                paymentInfo?.status === "paid" || paymentInfo?.status === "succeeded"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {paymentInfo?.status?.toUpperCase() || "UNPAID"}
            </p>
            <p className="mt-3 text-stone-700">
              <span className="font-semibold">Stripe ID:</span>{" "}
              {paymentInfo?.id || "—"}
            </p>
            <p className="mt-2 text-stone-700">
              <span className="font-semibold">Amount:</span> $
              {totalAmount?.toFixed(2)}
            </p>
          </div>

          {/* Ordered Items */}
          <div className="bg-white p-6 rounded-lg border border-stone-200 shadow-sm">
            <h3 className="text-xl font-playfair text-[#BC3F4A] mb-4">
              Ordered Items
            </h3>
            <ul className="divide-y divide-stone-200">
              {orderItems?.map((item) => (
                <li
                  key={item?._id}
                  className="flex justify-between items-center py-4"
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={item?.image}
                      alt={item?.name}
                      className="w-16 h-16 object-contain rounded border border-stone-200"
                    />
                    <Link
                      to={`/product/${item.product}`}
                      className="text-stone-800 font-medium hover:text-[#BC3F4A] transition"
                    >
                      {item?.name}
                    </Link>
                  </div>
                  <p className="text-stone-700">
                    {item?.quantity} × ${item?.price} ={" "}
                    <span className="font-semibold">
                      ${(item?.quantity * item?.price).toFixed(2)}
                    </span>
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* RIGHT: Sticky Summary */}
        <aside className="lg:col-span-1">
          <div className="sticky top-24 bg-[#fdfcf8] p-6 rounded-lg border border-stone-200 shadow-md">
            <h3 className="text-xl font-playfair text-[#BC3F4A] mb-4">
              Order Summary
            </h3>
            <p className="text-stone-700 mb-2">
              <span className="font-semibold">Order ID:</span>{" "}
              {order?._id?.substring(0, 10)}...
            </p>
            <p className="text-stone-700 mb-2">
              <span className="font-semibold">Status:</span>{" "}
              <span
                className={`px-2 py-1 text-xs font-medium rounded-md ${
                  orderStatus === "Delivered"
                    ? "bg-green-100 text-green-700"
                    : "bg-amber-100 text-amber-700"
                }`}
              >
                {orderStatus}
              </span>
            </p>
            <p className="text-stone-700 mb-4">
              <span className="font-semibold">Total:</span> $
              {totalAmount?.toFixed(2)}
            </p>
            <div className="flex flex-col gap-3">
              <Link
                to={`/receipt/order/${order?._id}`}
                className="w-full px-4 py-2 text-center rounded-md bg-stone-700 text-white hover:bg-stone-800 transition"
              >
                <i className="fa fa-print mr-1"></i> Download Receipt
              </Link>
              {/* <button
                className="w-full px-4 py-2 rounded-md bg-[#BC3F4A] text-white hover:bg-[#a3323b] transition"
              >
                Reorder Items
              </button> */}
            </div>
          </div>
        </aside>
      </section>
    </>
  );
};

export default OrderDetails;





